import React, { useEffect, useState } from 'react';
import { msalConfig, msalInstance, mockMode, setInstance, setMockMode } from './authConfig';
import { createRoot } from 'react-dom/client';
import { AuthenticatedTemplate, MsalProvider, UnauthenticatedTemplate } from '@azure/msal-react';
import AuthenticatedScreen from './Screens/AuthenticatedScreen';
import UnauthenticatedScreen from './Screens/UnauthenticatedScreen';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import { EventType, PublicClientApplication } from '@azure/msal-browser';

const useStyles = makeStyles(() => ({
  loading: {
    display: 'flex',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

const getAuthConfig = async () => {
  const res = await fetch('authconfig/authConfig.json');
  return await res.json();
};
const AppWithMsal = () => {
  const classes = useStyles();
  const [authConfigLoaded, setAuthConfigLoaded] = useState(false);
  useEffect(() => {
    const loadAuthConfig = async () => {
      const config = await getAuthConfig();

      if (config.mock) {
        setMockMode(true);
        setAuthConfigLoaded(true);
        return;
      }

      // After the Azure login MSAL has to send the user back to the page the login started on (e.g. a
      // shared /code:XXXX link), otherwise path and query string are lost on the redirect URI.
      msalConfig.auth = { ...config, navigateToLoginRequestUrl: true };
      setInstance(new PublicClientApplication(msalConfig));
      setAuthConfigLoaded(true);
      // Default to using the first account if no account is active on page load
      if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
        // Account selection logic is app dependent. Adjust as needed for different use cases.
        msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
      }

      // Listen for sign-in event and set active account
      msalInstance.addEventCallback((event) => {
        if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
          const account = event.payload.account;
          msalInstance.setActiveAccount(account);
        }
      });
    };
    loadAuthConfig();
  }, []);
  if (!authConfigLoaded) {
    return (
      <div className={classes.loading}>
        <CircularProgress color="primary" />
      </div>
    );
  }
  if (mockMode) {
    return <AuthenticatedScreen />;
  }

  return (
    <MsalProvider instance={msalInstance}>
      <>
        <UnauthenticatedTemplate>
          <UnauthenticatedScreen />
        </UnauthenticatedTemplate>

        <AuthenticatedTemplate>
          <AuthenticatedScreen />
        </AuthenticatedTemplate>
      </>
    </MsalProvider>
  );
};

// initial render
export const render = () => {
  createRoot(document.getElementById('root')).render(<AppWithMsal />);
};

render();
